import React from 'react';
import block from 'bem-cn-lite';

import {Tooltip, TooltipButtonProps} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import './NotifyTooltip.scss';

const b = block('notify-tooltip');

export interface NotifyTooltipProps extends ClassNameProps {
    title: string;
    content: string;
    actionButton: TooltipButtonProps;
    cancelButton: TooltipButtonProps;
    onCloseClick: () => void;
}

export const NotifyTooltip: React.FC<NotifyTooltipProps> = (props) => {
    const {title, content, actionButton, cancelButton, onCloseClick, className} = props;
    const anchorRef = React.useRef<HTMLDivElement>(null);

    return (
        <div className={b(null, className)}>
            <div className={b('tooltip-anchor')} ref={anchorRef} />

            <Tooltip
                size="l"
                tooltipClassName={b('tooltip')}
                theme={'announcement'}
                placement={['bottom-end']}
                autoclosable={false}
                initialOpen={true}
                hasArrow={false}
                hasClose={true}
                title={title}
                content={content}
                tooltipActionButton={actionButton}
                tooltipCancelButton={cancelButton}
                onCloseClick={onCloseClick}
                anchorRef={anchorRef}
            />
        </div>
    );
};
